import { documentReady } from "@sazka/utils/document-ready";
import { ProductPageAnalytics } from "./analytics-product-page";

documentReady(() => {
    const navigationWrap = document.querySelector(".cp-header__navigation--lottery");
    if (navigationWrap) {
        const navigationLinks = navigationWrap.querySelectorAll("nav a");
        navigationLinks.forEach((link) =>
            link.addEventListener("click", () => {
                const linkName = link.getAttribute("data-title");

                ProductPageAnalytics.pushClickNavigation(linkName);
            })
        );
    }
});
